import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-cfops-devolucao-edit',
  templateUrl: './cfops-devolucao-edit.component.html',
  standalone: false
})
export class CfopsDevolucaoEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/cfop-devolucao`;

  readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'CAT 83/2009' },
      { label: 'Dados de Processamento' },
      { label: 'Configurações' },
      { label: 'CFOPs de Devolução', link: '/cfops-devolucao' },
      { label: 'Edição CFOPs de Devolução' }
    ]
  };
  public readonly actions: PoPageDynamicEditActions = {
    save: 'cfops-devolucao',
  };

  fields: PoPageDynamicEditField[] = []
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;


  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema('cfop-devolucao').subscribe(data => {
      this.fields = data;
    });
  }

}
